const MediaCategorySelectEnum = {
    FreePhotoAdvertisement: 'FreePhotoAdvertisement',
    SignageAdvertisement: 'SignageAdvertisement',
    FreePhotoWatermark: 'FreePhotoWatermark',
}

export default MediaCategorySelectEnum;
